"use client";

import LogoBox from "@/components/LogoBox";
import IconifyIcon from "@/components/wrappers/IconifyIcon";
import { useEffect, useRef, useState } from "react";
// import { useNavigate } from 'react-router-dom'

import LeftSideBarToggle from "./components/LeftSideBarToggle";
import Notifications from "./components/Notifications";
import ProfileDropdown from "./components/ProfileDropdown";
import ThemeModeToggle from "./components/ThemeModeToggle";
import { fetchWrapper } from "@/helpers/fetch-wrapper";

const TopBar = () => {
	const navbarRef = useRef(null);

	useEffect(() => {
		window.addEventListener("scroll", () => {
			if (navbarRef.current) navbarRef.current.classList.toggle("topbar-active", window.scrollY > 100);
		});
	}, []);

     const [notifications, setNotifications] = useState([]); 
     const [notificationsCount, setNotificationsCount] = useState(0); 
     const [isLoading, setIsLoading] = useState(true);
     const [userData, setUserData] = useState([]); 

     useEffect(() => {
          const fetchUserData = async () => {
               try {
                    const response = await fetchWrapper.get('/api/users/getdata');

                    setUserData(response[0].userData); 
       
               } catch (error) {
                    console.error('An error occurred while fetching user data:', error);
               }
          };

          fetchUserData(); 

          const fetchNotifications = async () => {
               try {
                    setIsLoading(true);
                    const data = await fetchWrapper.get("/api/users/notifications");
                    setNotifications(data.userNotifications || []);
                    setNotificationsCount(data.userNotificationsCount || 0); 
               } catch (error) {
                    console.error("Error fetching notifications:", error);

                    setNotifications([]);
                    setNotificationsCount(0); 
               } finally {
                    setIsLoading(false);
               }
          };
          fetchNotifications();
     }, []);


	return (
		<header ref={navbarRef} className={`app-topbar `} id='header'>
			<div className='page-container topbar-menu'>
				<div className='d-flex align-items-center gap-2'>
					<LogoBox />
					<LeftSideBarToggle />
		
				</div>
				<div className='d-flex align-items-center gap-2'>
		
			
					<Notifications notifications={notifications} notificationsCount={notificationsCount} isLoading={isLoading} />
			
					
					<ThemeModeToggle />
					<ProfileDropdown userData={userData}/>
				</div>
			</div>
		</header>
	);
};
export default TopBar;
